export function startWithPath(menuPath, itemPath) {
    if (!menuPath || !itemPath) {
        return false;
    }
    const menuPathArray = menuPath.split('.');
    const itemPathArray = itemPath.split('.');
    return itemPathArray.every((token, index) => menuPathArray[index] === token);
}
